module.exports = __webpack_public_path__ + "img/2.cb387771.png";